export const EVENT_TYPE = {
  MOTION_DETECTION: 77,
  TAMPERED_CAMERA: 78,
};
